import type { TransactionCurrency } from '@contracts/payment/Currency';
import {
  BillingCurrency,
  toBillingCurrency,
} from '@contracts/payment/Currency';

export const isCurrencyDimmed = (
  currency: BillingCurrency,
  cellCurrency: TransactionCurrency,
) => {
  return (
    currency !== toBillingCurrency(cellCurrency) &&
    currency !== BillingCurrency.ALL
  );
};
